<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button icon="sync" @click="apiInventoryDetailsQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="库存查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">服务商：</div>
						<a-select v-model="query.facilitatorId" @change="facilitatorChange">
							<a-select-option v-for="(item, index) in facilitatorList" :key="index" :value="item.facilitatorId">{{item.facilitatorName}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">产品名称：</div>
						<a-select v-model="query.productId" @change="producChange">
							<a-select-option v-for="(item, index) in productList" :key="index" :value="item.productId">{{item.productName}}</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">选择价格：</div>
						<a-select v-model="query.priceId" @change="priceChange">
							<a-select-option :value="0">请选择</a-select-option>
							<a-select-option v-for="(item, index) in priceList" :key="index" :value="item.priceId">{{item.listingPrice / 100}}</a-select-option>
						</a-select>
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">库存名称：</div>
						<a-select v-model="query.inventoryId">
							<a-select-option :value="0">请选择</a-select-option>
							<a-select-option v-for="(item, index) in inventoryList" :key="index" :value="item.inventoryId">{{item.inventoryName}}</a-select-option>
						</a-select>
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
					<a-button type="primary" icon="search" @click="apiInventoryDetailsQueryList">查询</a-button>
					<a-button icon="redo" @click="apiOrdersQueryList" style="margin-left: 14px;">重置</a-button>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :row-selection="rowSelection" :columns="tableColumns" :data-source="tableData" row-key="inventoryDetailsId" :loading="tableLoading" :pagination="false">
				<span slot="useTotal" slot-scope="useTotal">
					<a-button type="link" @click="edit(useTotal)" >{{useTotal.inventoryTotal - useTotal.useTotal}}</a-button>
				</span>
				<span slot="inventoryDetailsState" slot-scope="inventoryDetailsState">
					<span v-if="inventoryDetailsState == 2">禁用</span>
					<span v-if="inventoryDetailsState == 3">启用</span>
					<span v-if="inventoryDetailsState == 5">失效</span>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>
		
		<!-- 修改弹窗 -->
		<a-modal class="qa-modal-half" title="修改" width="500px" :visible="editVisible" :confirm-loading="editConfirmLoading" @ok="editHandleOk" @cancel="editVisible = false"  :maskClosable="false" :keyboard="false">
			<a-form-model style="" ref="editRuleForm" :model="editForm" :label-col="{span: 4}" :wrapper-col="{span: 14}" :rules="addRules">
				<div class="qa-table-item-2">
					<a-form-model-item label="库存总数" has-feedback prop="inventoryTotal">
						<a-input v-model="editForm.inventoryTotal" placeholder="请输入库存名称" />
					</a-form-model-item>
					<a-form-model-item ></a-form-model-item>
				</div>
				<div class="qa-table-item-2">
					<a-form-model-item label="已售出数" has-feedback prop="inventoryTotal">
						<a-input v-model="editForm.useTotal" placeholder="已售出数" disabled />
					</a-form-model-item>
					<a-form-model-item ></a-form-model-item>
				</div>
				<div class="qa-table-item-2">
					<a-form-model-item label="有效时间" has-feedback prop="inventoryTotal">
						{{editForm.startTime}}
						<br>
						{{editForm.endTime}}
					</a-form-model-item>
					<a-form-model-item ></a-form-model-item>
				</div>
			</a-form-model>
		</a-modal>
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				facilitatorList: [],
				productList: [],
				priceList: [],
				inventoryList: [],
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					facilitatorId: 0,
					productId: 0,
					priceId: 0,
					inventoryId: 0,
				},
				mainNavigation:{},
				tableData: [],
				tableColumns: [
					{ title:'ID', key:'inventoryDetailsId', dataIndex:'inventoryDetailsId', align:'center'},
					{ title:'库存总数', key:'inventoryTotal', dataIndex:'inventoryTotal', align:'center'},
					{ title:'已售出', key:'useTotal', dataIndex:'useTotal', align:'center'},
					{ title:'剩余库存', key:'useTotal', align:'center', scopedSlots:{customRender:'useTotal'}},
					{ title:'开始时间', key:'startTime', dataIndex:'startTime', align:'center'},
					{ title:'结束时间', key:'endTime', dataIndex:'endTime', align:'center'},
					{ title:'状态', key:'inventoryDetailsState', dataIndex:'inventoryDetailsState', align:'center', scopedSlots:{customRender:'inventoryDetailsState'}},
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
				// 添加弹窗-start
				addRules: {
					inventoryTotal: [{ required: true, message: '请输入总库存数', trigger: 'blur' }],
					useTotal: [{ required: true, message: '', trigger: 'blur' }],
					
				},
				// 添加弹窗-end
				// 修改弹窗-start
				editVisible: false,
				editConfirmLoading: false,
				editForm: {
					inventoryId: '',
					inventoryTotal: 0,
				},
				// 修改弹窗-end
			};
		},
		methods: {
			//获取服务商列表
			async apiFacilitatorList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiFacilitatorList,this.query);
				if (res.code == 200) {
					this.facilitatorList = res.data
					this.query.facilitatorId = res.data[0].facilitatorId
					this.mainNavigation[0] = res.data[0]
					this.apiProductList()
					this.apiInventoryDetailsQueryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取产品列表
			async apiProductList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiProductList, {facilitatorId: this.query.facilitatorId});
				if (res.code == 200) {
					this.query.productId = ''
					this.productList = res.data
					this.query.productId = res.data[0].productId
					this.apiPriceList()
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取价格列表
			async apiPriceList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiPriceList, {productId: this.query.productId});
				if (res.code == 200) {
					this.priceList = res.data
					this.query.priceId = res.data[0].priceId
					this.apiInventoryList()
				} else {
					this.$message.error(res.msg)
				}
			},
			//获取库存设置列表
			async apiInventoryList() {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiInventoryList, {priceId: this.query.priceId});
				if (res.code == 200) {
					this.inventoryList = res.data
					this.query.inventoryId = res.data[0].inventoryId
				} else {
					this.$message.error(res.msg)
				}
			},
			
			//获取产品列表
			facilitatorChange(e) {
				this.priceList = []
				this.query.priceId = 0
				this.apiProductList()
			},
			producChange(e) {
				this.apiPriceList()
			},
			priceChange(e) {
				this.apiInventoryList()
			},
			
			//重置
			apiOrdersQueryList() {
				this.apiFacilitatorList()
			},

			//表格开始-搜索
			async apiInventoryDetailsQueryList() {
				this.tableLoading = true
				for(let i=0;i<this.facilitatorList.length;i++){
					if(this.facilitatorList[i].facilitatorId == this.query.facilitatorId) {
						this.mainNavigation[0] = this.facilitatorList[i]
					}
				}
				const {
					data: res
				} = await this.$http.post(this.navigation.apiInventoryDetailsQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					// this.$message.success(res.msg)
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiInventoryDetailsQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiInventoryDetailsQueryList()
			},
			//修改弹窗事件-开始
			edit(item){
				let items = JSON.parse(JSON.stringify(item))
				items.startTime = this.moment(item.startTime).format('YYYY-MM-DD HH:mm:ss')
				items.endTime = this.moment(item.endTime).format('YYYY-MM-DD HH:mm:ss')
				this.editForm = items
				this.editVisible = true
			},
			async apiInventoryDetailsEdit() {
				let data = JSON.parse(JSON.stringify(this.editForm))
				const {
					data: res
				} = await this.$http.post(this.navigation.apiInventoryDetailsEdit, data);
				if (res.code == 200) {
					this.$message.success(res.msg)
					this.$refs.editRuleForm.resetFields();
					this.apiInventoryDetailsQueryList()
					this.editConfirmLoading = false
					this.editVisible = false
				} else {
					this.$message.error(res.msg)
					this.editConfirmLoading = false
				}
			},
			
			editHandleOk() {
				this.$refs.editRuleForm.validate(valid => {
					if (valid) {
						this.apiInventoryDetailsEdit()
					} else {
					  return false;
					  this.editConfirmLoading = true
					}
				});
				
			},
			//修改弹窗事件-结束
			tableEdit() {
				if(this.tableSelectedRows.inventoryDetailsId > 0) {
					this.edit(this.tableSelectedRows)
				}else{
					this.$message.warning('请选择要修改的数据');
				}
			}
			
		},
		computed: {
			rowSelection() {
				let that = this
				return {
					type: 'radio',
					onChange: (selectedRowKeys, selectedRows) => {
						// console.log(selectedRows);
						that.tableSelectedRows = selectedRows[0];
					},
					// getCheckboxProps: record => ({
					// 	props: {
					// 		disabled: record.name === 'Disabled User', // Column configuration not to be checked
					// 		name: record.name,
					// 	},
					// }),
				};
			},
		},
		created() {
			this.apiFacilitatorList()
		}
	};
</script>

<style scoped>
	
</style>
